<mat-accordion class="d-flex flex-column gap-3">
  <mat-expansion-panel [expanded]="true" class="bg-white rounded shadow2">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-md" i18n> Policies </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngTemplateOutlet]="policiesFormTmpl"></ng-template>
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSavePolicy(policyForm)">
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel class="bg-white rounded shadow2">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-md" i18n> Damage Policy </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngTemplateOutlet]="damageFormTmpl"></ng-template>
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSaveDamagePolicy(damagePolicyForm)">
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel class="bg-white rounded shadow2">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-md" i18n> Cancellation Exceptions </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngTemplateOutlet]="cancellationFormTmpl"></ng-template>
    <div class="d-flex align-items-center justify-content-end">
      <button
        class="btn btn-secondary-info"
        [disabled]="isLoading"
        (click)="onSaveCancelException(cancellationExceptionsForm)"
      >
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel class="bg-white rounded shadow2">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-md" i18n> Invoice Settings </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngTemplateOutlet]="invoiceSettingsFormTmpl"></ng-template>
    <div class="d-flex align-items-center justify-content-end">
      <button
        class="btn btn-secondary-info"
        [disabled]="isLoading"
        (click)="onSaveInvoiceSettings(invoiceSettingsForm)"
      >
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel class="bg-white rounded shadow2">
    <mat-expansion-panel-header>
      <mat-panel-title class="text-md" i18n> Misc </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template [ngTemplateOutlet]="miscFormTmpl"></ng-template>
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSaveMisc(miscForm)">
        <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
        <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
        <ng-container i18n>Save</ng-container>
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #policiesFormTmpl>
  <form [formGroup]="policyForm">
    <div class="row">
      <div class="col-md-6" formGroupName="booking_model">
        <mat-form-field2>
          <mat-label i18n>Booking Model Type</mat-label>
          <mat-select formControlName="type" required>
            <mat-option *ngFor="let item of bookingModelOptions" [value]="item.value">
              {{ item.label }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              policyForm.get('booking_model.type').touched && policyForm.get('booking_model.type').hasError('required')
            "
          >
            <ng-container i18n>Booking model is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 formGroupName="accepted_payment_types">
          <app-select
            placeholder="Accepted Payment Types"
            i18n-placeholder
            formControlName="codes"
            [multiple]="true"
            [items]="paymentTypeOptions"
            bindValue="code"
            bindLabel="name"
          >
          </app-select>
        </mat-form-field2>
      </div>
    </div>
    <div
      class="alert alert-secondary-warning2 align-items-start"
      *ngIf="policyForm.get('booking_model.type').value === bdcBookingModelType.RTB"
    >
      <div class="alert-content">
        <h6 i18n class="mb-1">When using request to book, the booking process will be as follows:</h6>
        <ul class="ml-0 pl-2">
          <li i18n>
            Guests who want to make booking with the checkin that is more than 48 hours in the future will be able to
            find your apartment and send the booking request.
          </li>
          <li i18n>You'll have 24 hours to accept or decline the request.</li>
          <li i18n>Guests will have 24 hours to finish their booking and confirm their stay.</li>
        </ul>
      </div>
    </div>
    <hr />
    <h6 i18n>Pets Policy</h6>
    <div class="row">
      <ng-container [formGroup]="policyForm.get('pets')">
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Pets Allowed</mat-label>
            <mat-select formControlName="pets_allowed">
              <mat-option *ngFor="let item of petsAllowedOptions" [value]="item">
                {{ item | titleCase }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Pets Price Type</mat-label>
            <mat-select formControlName="pets_price_type">
              <mat-option *ngFor="let item of petsPriceTypeOptions" [value]="item">
                {{ item | titleCase }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
    <hr />
    <h6 i18n>Children Policy</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex align-items-center gap-3">
          <ng-container [formGroup]="policyForm.get('children_policies')">
            <mat-form-field2 class="mat-block">
              <input type="number" matInput formControlName="min_age" placeholder="Min Children Age" i18n-placeholder />
              <mat-error *ngIf="policyForm.get('children_policies.min_age').hasError('min')" i18n>
                Min Children Age must be greater than or equal to 0
              </mat-error>
            </mat-form-field2>
            <mat-checkbox formControlName="allow_children">Allow Children</mat-checkbox>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #damageFormTmpl>
  <form [formGroup]="damagePolicyForm">
    <div class="form-field-label mb-2" i18n>Do your guests pay a damage deposit?</div>
    <mat-radio-group [formControl]="isDamagePolicyEnabledCtrl" class="d-flex flex-column mb-3">
      <mat-radio-button [value]="true">Yes</mat-radio-button>
      <div *ngIf="isDamagePolicyEnabledCtrl.value" class="ml-4">
        <mat-radio-group formControlName="policy_type" class="d-flex flex-column">
          <mat-radio-button [value]="bdcDamagePolicyType.HANDLED_BY_BOOKING_COM">
            <div>
              <div i18n>I want to set up a damage programme that Booking.com will facilitate for me</div>
              <div class="text-light" i18n>Guests only pay if they cause damage during their stay</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [value]="bdcDamagePolicyType.HANDLED_BY_PROPERTY">
            <div>
              <div i18n>I want to handle damage deposits myself</div>
              <div class="text-light" i18n>Guests pay you a damage deposit directly</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>

    <ng-container *ngIf="isDamagePolicyEnabledCtrl.value && damagePolicyForm.get('policy_type') as policyTypeCtrl">
      <hr />
      <div class="row">
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Enter the maximum amount a guest could be charged for damage</mat-label>
            <input type="number" matInput formControlName="amount" placeholder="Amount" i18n-placeholder required />
            <span matSuffix class="text-nowrap"
              >({{ property?.currency_code }}) <ng-container i18n>Per Stay</ng-container></span
            >
            <mat-error *ngIf="damagePolicyForm.get('amount').hasError('required')">
              <ng-container i18n>Amount is required</ng-container>
            </mat-error>
            <mat-error *ngIf="damagePolicyForm.get('amount').hasError('min')">
              <ng-container i18n>Amount must be greater than or equal to 0</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <ng-container *ngIf="policyTypeCtrl.value === bdcDamagePolicyType.HANDLED_BY_PROPERTY">
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>How do you want to collect this payment?</mat-label>
              <mat-select formControlName="collection_mode" required>
                <mat-option *ngFor="let item of damageCollectionModeOptions" [value]="item">
                  {{ item | titleCase }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="damagePolicyForm.get('collection_mode').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>When will you collect this?</mat-label>
              <mat-select formControlName="collection_when" required>
                <mat-option *ngFor="let item of damageCollectionWhenOptions" [value]="item">
                  {{ item | titleCase }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="damagePolicyForm.get('collection_when').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>How do you want to return the damage deposit?</mat-label>
              <mat-select formControlName="return_mode" required>
                <mat-option *ngFor="let item of damageReturnModeOptions" [value]="item">
                  {{ item | titleCase }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="damagePolicyForm.get('return_mode').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>When will damage deposits be returned?</mat-label>
              <mat-select formControlName="return_when" required>
                <mat-option *ngFor="let item of damageReturnWhenOptions" [value]="item">
                  {{ item | titleCase }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="damagePolicyForm.get('return_when').hasError('required')">
                <ng-container i18n>Value is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
        <div class="col-md-12" *ngIf="policyTypeCtrl.value === bdcDamagePolicyType.HANDLED_BY_BOOKING_COM">
          <mat-checkbox formControlName="damage_programme_terms_agreed" required
            >Agree to the terms for the damage programme</mat-checkbox
          >
          <div>
            <mat-error *ngIf="damagePolicyForm.get('damage_programme_terms_agreed').hasError('required')" i18n>
              You must agree to the terms for the damage programme if you choose to handle damage via Booking.com
            </mat-error>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</ng-template>

<ng-template #cancellationFormTmpl>
  <form [formGroup]="cancellationExceptionsForm">
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex align-items-center gap-3" formGroupName="grace_period">
          <mat-form-field2
            class="mat-block"
            *ngIf="cancellationExceptionsForm.get('grace_period.after_booking') as ctrl"
          >
            <mat-label i18n>After Booking</mat-label>
            <mat-select formControlName="after_booking">
              <mat-option *ngFor="let item of cancellationGracePeriodOptions" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')"> After Booking is required </mat-error>
          </mat-form-field2>
          <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="d-flex align-items-center gap-3" formGroupName="advance_cancellation">
          <mat-form-field2
            class="mat-block"
            *ngIf="cancellationExceptionsForm.get('advance_cancellation.before_check_in') as ctrl"
          >
            <mat-label i18n>Before Check In</mat-label>
            <mat-select formControlName="before_check_in">
              <mat-option *ngFor="let item of cancellationBeforeCheckInOptions" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')"> Before Check In is required </mat-error>
          </mat-form-field2>
          <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #miscFormTmpl>
  <form [formGroup]="miscForm">
    <ng-container formGroupName="property_settings">
      <div class="row mb-2">
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Price Type</mat-label>
            <mat-select formControlName="pricing_type">
              <mat-option *ngFor="let item of priceTypeOptions" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </div>
      <div class="row gap-row-2">
        <div class="col-md-6">
          <mat-checkbox formControlName="require_cvc">Require CVC</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="require_booker_address">Require Guest Address</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="require_booker_phone_number">Require Guest Phone Number</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="auto_replenish">Auto Replenish</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="replenish_closed_rooms">Replenish Closed Rooms</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="view_cc_details">View Guest's Credit Card Details</mat-checkbox>
        </div>
        <div class="col-md-6">
          <mat-checkbox formControlName="allow_smoking">Allow Smoking</mat-checkbox>
        </div>
      </div>
      <hr />
      <h6 i18n>Curfew Time</h6>
      <div class="row gap-row-3">
        <ng-container formGroupName="curfew">
          <div class="col-md-12">
            <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="miscForm.get('property_settings.curfew.start') as ctrl">
              <mat-label i18n>Start Time</mat-label>
              <mat-select formControlName="start">
                <mat-option *ngFor="let time of time30MinsOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Start Time is required </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="miscForm.get('property_settings.curfew.end') as ctrl">
              <mat-label i18n>End Time</mat-label>
              <mat-select formControlName="end">
                <mat-option *ngFor="let time of time30MinsOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> End Time is required </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
      </div>
      <hr />
      <h6 i18n>Age Limit To Check-In</h6>
      <div class="row gap-row-3">
        <ng-container formGroupName="age_restriction">
          <div class="col-md-12">
            <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="miscForm.get('property_settings.age_restriction.min') as ctrl">
              <input type="text" matInput formControlName="min" placeholder="Min Age" i18n-placeholder />
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Min age is required </mat-error>
              <mat-error *ngIf="ctrl.hasError('min')" i18n> Min value is 18 </mat-error>
              <mat-error *ngIf="ctrl.hasError('max')" i18n> Max value is 99 </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="miscForm.get('property_settings.age_restriction.max') as ctrl">
              <input type="text" matInput formControlName="max" placeholder="Max Age" i18n-placeholder />
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Max age is required </mat-error>
              <mat-error *ngIf="ctrl.hasError('min')" i18n> Min value is 18 </mat-error>
              <mat-error *ngIf="ctrl.hasError('max')" i18n> Max value is 99 </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
      </div>
      <hr />
      <h6 i18n>Long Stay Option</h6>
      <div class="row gap-row-3">
        <ng-container formGroupName="long_stay">
          <div class="col-md-12">
            <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
          </div>
          <div class="col-md-4">
            <mat-form-field2 *ngIf="miscForm.get('property_settings.long_stay.max_length_of_stay') as ctrl">
              <mat-label i18n>Max Length of Stay</mat-label>
              <mat-select formControlName="max_length_of_stay">
                <mat-option *ngFor="let item of longStayOptions" [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n>
                Max Length of Stay is required
              </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <hr />
    <h6 i18n>Renting Details For Bed Linens And Towels</h6>
    <div class="row gap-row-3">
      <ng-container formGroupName="bed_linen_policy">
        <div class="col-md-12">
          <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block" *ngIf="miscForm.get('bed_linen_policy.amount') as ctrl">
            <input type="number" matInput formControlName="amount" placeholder="Amount" i18n-placeholder />
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Amount is required </mat-error>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
    <hr />
    <h6 i18n>Quiet Hours</h6>
    <div class="row gap-row-3">
      <ng-container formGroupName="quiet_hours">
        <div class="col-md-12">
          <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block" *ngIf="miscForm.get('quiet_hours.start') as ctrl">
            <mat-label i18n>Start Time</mat-label>
            <mat-select formControlName="start">
              <mat-option *ngFor="let time of time60MinsOptions" [value]="time.value">
                {{ time.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Start Time is required </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block" *ngIf="miscForm.get('quiet_hours.end') as ctrl">
            <mat-label i18n>End Time</mat-label>
            <mat-select formControlName="end">
              <mat-option *ngFor="let time of time60MinsOptions" [value]="time.value">
                {{ time.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> End Time is required </mat-error>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
    <hr />
    <h6 i18n>Renovation Dates</h6>
    <div class="row gap-row-3">
      <ng-container formGroupName="renovation">
        <div class="col-md-12">
          <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block" *ngIf="miscForm.get('renovation.start') as ctrl">
            <app-mat-date-input
              formControlName="start"
              i18n-placeholder
              placeholder="Start Date"
              [showTime]="false"
              [max]="miscForm.get('renovation.end').value"
              [required]="ctrl | required"
            ></app-mat-date-input>

            <span matPrefix><i class="fal fa-calendar"></i> </span>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
              <ng-container i18n>Start Date is required </ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-4">
          <mat-form-field2 class="mat-block" *ngIf="miscForm.get('renovation.end') as ctrl">
            <app-mat-date-input
              formControlName="end"
              i18n-placeholder
              placeholder="End Date"
              [showTime]="false"
              [min]="miscForm.get('renovation.start').value"
              [required]="ctrl | required"
            ></app-mat-date-input>

            <span matPrefix><i class="fal fa-calendar"></i> </span>
            <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
              <ng-container i18n>End Date is required </ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </ng-container>
    </div>
    <hr />
    <h6 i18n>French Tax Details</h6>
    <div class="alert alert-secondary-warning">
      <i class="far fa-exclamation-triangle alert-icon"></i>
      <div class="alert-content" i18n>
        Only applicable for countries: France, Martinique, Guadeloupe, French Guiana, Reunion, Mayotte.
      </div>
    </div>
    <div class="row gap-row-3">
      <ng-container formGroupName="french_tax_details">
        <div class="col-md-4">
          <mat-checkbox
            formControlName="declare_revenue"
            matTooltip="Specifies whether the property declares revenues as professional for direct tax purposes."
            i18n-matTooltip
            >Declare Revenue</mat-checkbox
          >
        </div>
        <div class="col-md-4">
          <mat-checkbox
            formControlName="has_vat"
            matTooltip="Specifies whether the property has a registered VAT for this activity."
            i18n-matTooltip
            >Has VAT</mat-checkbox
          >
        </div>
        <div class="col-md-4">
          <mat-checkbox
            formControlName="registered_in_rcs"
            matTooltip="Specifies whether the property is registered as a professional at the trade commercial register"
            i18n-matTooltip
            >Registered in RCS</mat-checkbox
          >
        </div>
      </ng-container>
    </div>
  </form>
</ng-template>

<ng-template #invoiceSettingsFormTmpl>
  <form [formGroup]="invoiceSettingsForm">
    <div class="row gap-row-3">
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="legal_name" placeholder="Legal Name" i18n-placeholder />
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="contact_person" placeholder="Contact Person" i18n-placeholder />
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <mat-label i18n>Notification Channel</mat-label>
          <mat-select formControlName="notification_channel">
            <mat-option *ngFor="let item of notificationChannelOptions" [value]="item">
              {{ item | titleCase }}
            </mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <div class="col-md-8">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="address" placeholder="Address" i18n-placeholder />
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="city" placeholder="City" i18n-placeholder />
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="state" placeholder="State" i18n-placeholder />
        </mat-form-field2>
      </div>
      <div class="col-md-4">
        <app-country-select
          [codeCtrl]="invoiceSettingsForm.get('country_code')"
          [showBlankItem]="false"
        ></app-country-select>
      </div>
      <div class="col-md-4">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="postal_code" placeholder="Postal Code" i18n-placeholder />
        </mat-form-field2>
      </div>
    </div>
    <ng-container *ngIf="invoiceSettingsForm.get('brazil_tax_details').enabled">
      <hr />
      <h6 i18n>Brazil Tax Details</h6>
      <div class="row gap-row-3">
        <ng-container
          formGroupName="brazil_tax_details"
          *ngIf="invoiceSettingsForm.get('brazil_tax_details') as brazilTaxForm"
        >
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="brazilTaxForm.get('tax_payer_number_type') as ctrl">
              <mat-label i18n>Tax Payer Number Type</mat-label>
              <mat-select formControlName="tax_payer_number_type">
                <mat-option *ngFor="let item of taxPayerNumberTypeOptions" [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n>
                Tax Payer Number Type is required
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="brazilTaxForm.get('tax_payer_number') as ctrl">
              <mat-label i18n>Tax Payer Number</mat-label>
              <input
                type="text"
                matInput
                formControlName="tax_payer_number"
                placeholder="Tax Payer Number"
                i18n-placeholder
              />
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n>
                Tax Payer Number is required
              </mat-error>
              <mat-error *ngIf="ctrl.hasError('pattern')"> Tax Payer Number must be digits only </mat-error>
              <mat-error *ngIf="ctrl.hasError('minlength') || ctrl.hasError('maxlength')">
                Tax Payer Number must be
                {{ ctrl.errors.minlength?.requiredLength || ctrl.errors.maxlength?.requiredLength }} characters
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="brazilTaxForm.get('city_hall_id') as ctrl">
              <mat-label i18n>City Hall ID</mat-label>
              <input type="text" matInput formControlName="city_hall_id" placeholder="City Hall ID" i18n-placeholder />
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> City Hall ID is required </mat-error>
              <mat-error *ngIf="ctrl.hasError('minlength') || ctrl.hasError('maxlength')" i18n>
                City Hall ID must be 8 characters
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2 class="mat-block" *ngIf="brazilTaxForm.get('email') as ctrl">
              <mat-label i18n>Email</mat-label>
              <input type="email" matInput formControlName="email" placeholder="Email" i18n-placeholder />
              <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')" i18n> Email is required </mat-error>
              <mat-error *ngIf="ctrl.hasError('email')" i18n> Email is invalid </mat-error>
            </mat-form-field2>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </form>
</ng-template>
